import React from 'react';
import { useHistory } from 'react-router';

const BaseLayout = React.lazy(() => import('../layouts/BaseLayout/BaseLayout'))

const Page404: React.FC = () => {
  const history = useHistory();

  return (
    <BaseLayout>
      <div className="page-wrapper">
        <div className="containerx">
          <div className="row">
            <div className="col-12">
              <div
                className="auth-form-container text-center"
                style={{ textAlign: 'center' }}
              >
                <p className="auth-form-title">Page not found</p>
                <p className="auth-form-text" style={{ margin: '36px 0' }}>
                  Unfortunately the page you’re looking for isn’t here.
                </p>
                <button
                  type="button"
                  className="tr8s-button green hom"
                  onClick={() => history.push('/')}
                >
                  Return To Home{' '}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}

export default Page404;
